'use client'

import { memo } from 'react'

import ChartCardLoading from '@/components/charts/components/ChartCardLoading'

const VaultV2ChartTotalDepositLoading = () => {
  return (
    <ChartCardLoading
      className="gap-lg"
      chartClassName="h-[224px]"
      titleClassName="w-[129px]"
      valueClassName="h-[44px] w-[172px]"
      controls={['h-8 w-[76px] md:h-8 md:w-[101px]', 'h-8 w-[103px]']}
    />
  )
}

export default memo(VaultV2ChartTotalDepositLoading)
